'use strict';

// picturefill isn't an es6 module, so grab everything as picturefill
import * as picturefill from 'picturefill';

// invoke picturefill globally before anything
picturefill();

// URLSearchParams will self-invoke if required
import 'url-search-params-polyfill';

// our polyfills will self-invoke if required
import 'utils/polyfills';

// widgets will invoke themselves
import 'widgets/calendar';
import 'widgets/search-page';
import 'widgets/performance-list';
import 'widgets/header-calendar';
import 'widgets/newsletter';

// modules will invoke themselves
import 'modules/spotlight';
import 'modules/truncator';
import 'modules/toggle';
import 'modules/video-resize';
import 'modules/headroom';
import 'modules/scroller';
import 'modules/gallery';
import 'modules/accordion';
import 'modules/swiftype';
import 'modules/slideshow';
import 'modules/aos';
import 'modules/navigation';
import 'modules/navigation-mobile';
import 'modules/inline-blockquote-sizer';
import 'modules/directory';
import 'modules/video-modal';
import 'modules/scroll-to';
import 'modules/tabbing';
import 'modules/waypoint';
import 'modules/membership-donation';
import 'modules/header-video';
import 'modules/scroll-prompt';
import 'modules/messages';
import 'modules/bamboo-hr';

// Added for SS integration
import 'modules/user-status';
import 'modules/cart-status';
import 'modules/promo-messages';
